module.exports = __webpack_public_path__ + "static/img/TA700.830dee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/problem/TA700.png
// module id = 3n4C
// module chunks = 0